import {defineStore} from "pinia";
import {FacturaOtroIngreso} from "@/models/FacturaOtroIngreso";
import {FacturaConsumoAgua} from "@/models/FacturaConsumoAgua";
import {Cuenta} from "@/models/Cuenta";

export const recaudacionStore = defineStore("recaudacionStore", {
    state: () =>
        ({
            loading: false as boolean,

            isNewOtroIngreso: true as boolean,
            facturaOtroIngreso: new FacturaOtroIngreso() as FacturaOtroIngreso,

            isNewConsumoAgua: true as boolean,
            facturaConsumoAgua: new FacturaConsumoAgua() as FacturaConsumoAgua,

            facturaPrintOtroIngreso: null as any,
            facturaPrintConsumo: null as any,

            cuentas: [] as Cuenta[],
            cuotas: [] as any[],
            facturas: [] as any[],
            facturasCajero: [] as any[],
            cantidadFacturas: null as any,
            totalRecaudado: null as any,
            detalleCajero: null as any,
            fechaLiteral: '' as string,
            pagination: {
                per_page: 0,
                current_page: 1,
                last_page: 0,
            },
            showDialogHistorial: false as boolean,
            historiales: [] as any[],

            resumen: {} as any,

            cheques: [] as any[],
            cheque: {
                banco: '',
                girado: '',
                importe: ''
            } as any,
            dinero:'',
            resumenTotalizado: [] as any[],
            resumenTotalizadoTotales: [] as any[],
            
        }),
});